import { Column, Row } from 'common/components/common/style';
import { Image } from 'common/components/image';
import { H2 } from 'common/components/Typography';
import { getScalablePixel } from 'common/utils';
import styled from 'styled-components';

export const PopupContainer = styled(Column)`
  align-items: center;
  padding: 0 ${getScalablePixel(100)}px;
`;

export const ButtonContainer = styled(Row)`
  padding-top: ${getScalablePixel(42)}px;
  flex: 1;
  width: 100%;
  justify-content: center;
  & > * {
    margin: 0 ${getScalablePixel(8)}px;
  }
`;

export const Title = styled(H2)`
  text-transform: uppercase;
`;

export const IconStyled = styled(Image)`
  width: ${getScalablePixel(183)}px;
  height: ${getScalablePixel(183)}px;
  padding-bottom: ${getScalablePixel(28)}px;
`;
